import { render, staticRenderFns } from "./avatarUpload.vue?vue&type=template&id=763fb3ee&scoped=true"
import script from "./avatarUpload.vue?vue&type=script&lang=js"
export * from "./avatarUpload.vue?vue&type=script&lang=js"
import style0 from "./avatarUpload.vue?vue&type=style&index=0&id=763fb3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763fb3ee",
  null
  
)

export default component.exports